export default __webpack_public_path__ + "static/media/Goat.ede6436a.webp";